import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sources-card" }
const _hoisted_2 = {
  key: 0,
  class: "sources-control"
}
const _hoisted_3 = { class: "arrows" }
const _hoisted_4 = { class: "counter" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Divider = _resolveComponent("Divider")
  const _component_SourceItem = _resolveComponent("SourceItem")
  const _component_SmoothResize = _resolveComponent("SmoothResize")
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createBlock(_component_Popover, {
    class: "popover-wrapper",
    "popper-class": "sources-popover",
    teleported: "",
    width: "29.9rem",
    placement: "bottom-start",
    trigger: "hover",
    "show-arrow": false,
    "show-after": 200,
    persistent: false,
    mask: _ctx.$responsive.mobile,
    "z-index": 3000,
    onShow: _cache[2] || (_cache[2] = $event => ($data.hover = true)),
    onHide: _cache[3] || (_cache[3] = $event => ($data.hover = false))
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["sources-link pointer", {hover: $data.hover}])
      }, _toDisplayString($props.text), 3 /* TEXT, CLASS */)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        ($options.sources.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Icon, {
                  class: "pointer",
                  size: _ctx.$responsive.mobile ? '2rem' : '1.6rem',
                  icon: "arrow-left",
                  stroke: "var(--brand-500)",
                  onClick: _cache[0] || (_cache[0] = $event => ($options.setSource($data.cur_idx - 1)))
                }, null, 8 /* PROPS */, ["size"]),
                _createVNode(_component_Icon, {
                  class: "pointer",
                  size: _ctx.$responsive.mobile ? '2rem' : '1.6rem',
                  icon: "arrow-right",
                  stroke: "var(--brand-500)",
                  onClick: _cache[1] || (_cache[1] = $event => ($options.setSource($data.cur_idx + 1)))
                }, null, 8 /* PROPS */, ["size"])
              ]),
              _createElementVNode("div", _hoisted_4, _toDisplayString($data.cur_idx + 1) + "/" + _toDisplayString($options.sources.length), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_Divider, { m: "0" }),
        _createVNode(_component_SmoothResize, {
          active: `source-${$data.cur_idx}`
        }, _createSlots({ _: 2 /* DYNAMIC */ }, [
          _renderList($options.sources, (_, idx) => {
            return {
              name: `source-${idx}`,
              fn: _withCtx(() => [
                _createVNode(_component_SourceItem, {
                  class: "source-item",
                  source: $options.current
                }, null, 8 /* PROPS */, ["source"])
              ])
            }
          })
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["active"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["mask"]))
}